/*
   useMyMutation: common code for mutations
   mutationFunction:
        the mutate function -- the actual fetch
        takes 1 par (the object to be created/deleted/modified)
        returns a Promise - resolves in truthy if ok
        throw if a problem
   messageOnSuccess:
        a function that takes the object and returns a message-string
 */
import {useMutation, useQueryClient} from "@tanstack/react-query";


export function useMyMutation(mutationFunction, query_id, messageOnSuccess) {
    const queryClient = useQueryClient()


    const mutation = useMutation({
        mutationFn: mutationFunction,
        onSuccess: async (result, book) => {
            await queryClient.invalidateQueries([query_id])
        },
    });
    return async (obj) => {
        try {
            return await mutation.mutateAsync(obj)
        } catch (e) {
            console.log("error mutation message = " + e);
        }
    };
}